export const ANIMATION_OPTIONS = [
  { id: "fade", label: "Fade in" },
  { id: "slide-up", label: "Slide from bottom" },
  { id: "slide-right", label: "Slide from left" },
  { id: "slide-left", label: "Slide from right" },
  { id: "zoom-in", label: "Appear & zoom in" },
];
